
export class Country {
    countryId : number ;
    countryTitle : string; 
    nationalityTitle: string;

    constructor() {
    }
}


